import { render, staticRenderFns } from "./detail-dialog.vue?vue&type=template&id=409d8112&scoped=true&"
import script from "./detail-dialog.vue?vue&type=script&lang=js&"
export * from "./detail-dialog.vue?vue&type=script&lang=js&"
import style0 from "./detail-dialog.vue?vue&type=style&index=0&id=409d8112&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409d8112",
  null
  
)

export default component.exports